import { urlConfig } from './url.config';

export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1A_PYC_CONSMR_SIGNUP_SIGNIN",
    payLinkPasswordlessSignIn: "B2C_1A_PYC_CONSMR_PASSWORDLESS_SIGNIN",
    forgotPassword: "B2C_1A_PYC_CONSMR_PASSWORDRESET",
    editProfile: "B2C_1A_PYC_CONSMR_PROFILEEDIT",
  },
  authorities: {
    signUpSignIn: {
      authority: urlConfig.B2C_SIGN_UP_IN_AUTHORITY,
    },
    payLinkPasswordlessSignIn: {
      authority: urlConfig.B2C_PAYLINK_PASSWORDLESS_AUTHORITY,
    },
    forgotPassword: {
      authority: urlConfig.B2C_FORGOT_PASSWORD_AUTHORITY,
    },
    editProfile: {
      authority: urlConfig.B2C_EDIT_PROFILE_AUTHORITY,
    },
  },
  authorityDomain: urlConfig.B2C_AUTHORITY_DOMAIN,
};
